import { createAction, handleActions, Action } from 'redux-actions'

// Name Spaced Action Types
const CHANGE_PAGE = 'Quiz/CHANGE_PAGE'
const FINISH_QUIZ = 'Quiz/FINISH_QUIZ'
const ADD_SELECTED_INDEX = 'Quiz/ADD_SELECTED_INDEX'
const REMOVE_SELECTED_INDEX = 'Quiz/REMOVE_SELECTED_INDEX'
const RESET = 'Quiz/RESET'

export const actions = {
  CHANGE_PAGE,
  FINISH_QUIZ,
  ADD_SELECTED_INDEX,
  REMOVE_SELECTED_INDEX
}

type SelectedIndexPayload = { pageNumber: number, index: number }
type QuizActionCreators = {
  changePage: number => Action<number>,
  finishQuiz: () => Action<>,
  reset: () => Action,
  addSelectedIndex: (
    payload: SelectedIndexPayload
  ) => Action<SelectedIndexPayload>,
  removeSelectedIndex: (
    payload: SelectedIndexPayload
  ) => Action<SelectedIndexPayload>
}

export const actionCreators: QuizActionCreators = {
  changePage: createAction(CHANGE_PAGE),
  finishQuiz: createAction(FINISH_QUIZ),
  reset: createAction(RESET),
  addSelectedIndex: createAction(ADD_SELECTED_INDEX),
  removeSelectedIndex: createAction(REMOVE_SELECTED_INDEX)
}

export type QuizState = {
  quizPage: number,
  selectedIndicesPerPage: { [number]: Array<number> },
  displayResults: boolean
}
export const initialState: QuizState = {
  quizPage: 0,
  selectedIndicesPerPage: {
    0: []
  },
  displayResults: false
}

export default handleActions(
  {
    [CHANGE_PAGE]: (state, action: Action<number>) => ({
      ...state,
      quizPage: state.quizPage + action.payload
    }),
    [FINISH_QUIZ]: state => {
      return {
        ...state,
        displayResults: true
      }
    },
    [ADD_SELECTED_INDEX]: (
      state: QuizState,
      action: Action<SelectedIndexPayload>
    ) => {
      const { pageNumber, index } = action.payload
      const currentSelectedIndices: Array<number> =
        state.selectedIndicesPerPage[pageNumber] || []
      const selectedIndicesWithAddedValue = [...currentSelectedIndices, index]

      return {
        ...state,
        selectedIndicesPerPage: {
          ...state.selectedIndicesPerPage,
          [pageNumber]: selectedIndicesWithAddedValue
        }
      }
    },
    [REMOVE_SELECTED_INDEX]: (
      state: QuizState,
      action: Action<SelectedIndexPayload>
    ) => {
      const { pageNumber, index } = action.payload
      const currentSelectedIndices: Array<number> =
        state.selectedIndicesPerPage[pageNumber] || []
      const selectedIndicesWithAddedValue = currentSelectedIndices.filter(
        idx => idx !== index
      )
      return {
        ...state,
        selectedIndicesPerPage: {
          ...state.selectedIndicesPerPage,
          [pageNumber]: selectedIndicesWithAddedValue
        }
      }
    },
    [RESET]: () => initialState
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/redux/reducers/quiz/quizReducer.js